var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSparkle02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#icon_sparkle02_svg__a)",
  d: "M7.339 1.525c.226-.512 1.03-.525 1.271-.02.563 1.174 1.435 2.759 2.419 3.698.887.847 2.313 1.597 3.41 2.1.514.234.51 1.05-.006 1.282-1.09.488-2.5 1.219-3.37 2.057-.975.937-1.807 2.518-2.349 3.72-.235.523-1.079.518-1.308-.008-.493-1.13-1.235-2.577-2.108-3.459-.921-.93-2.462-1.707-3.645-2.213-.527-.226-.54-1.07-.018-1.309 1.113-.509 2.536-1.266 3.41-2.133C6 4.294 6.817 2.706 7.34 1.525"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_sparkle02_svg__a",
  x1: 12.024,
  x2: 3.975,
  y1: 11.975,
  y2: 4.025,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6523A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.589,
  stopColor: "#FF8418"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.971,
  stopColor: "#F9DDA9"
})))));
export default SvgIconSparkle02;